import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";

/** <img> for a stored file that first fetches a short-lived, download-only token so the
 *  session token never ends up in the URL. Shows an empty, correctly-sized box until the
 *  token is ready, then swaps in the image. */
export const AuthedImage = ({ fileId, className, alt = "", testid, ...rest }) => {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let alive = true;
    setSrc("");
    fileUrl(fileId)
      .then((u) => {
        if (alive) setSrc(u);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [fileId]);
  if (!src)
    return <div className={className} aria-label={alt} data-testid={testid} />;
  return <img src={src} alt={alt} className={className} data-testid={testid} {...rest} />;
};

export default AuthedImage;
